const EDIT= 'Edit'
const NO_ACCESS = 'No Access'
const READ_ONLY='Read only'
const EXPORT = 'Export'
const NO_EXPORT ='No export'
const FINALIZE = 'Finalize'
const NO_FINALIZE = 'No Finalize'

export {NO_ACCESS,READ_ONLY,EDIT,EXPORT,NO_EXPORT,FINALIZE,NO_FINALIZE}